import {
  ProjectWorkItemsPage,
  loadProjectWorkItems,
  workItemsSearchSchema,
} from "@/components/work-items/project-list";
import { createFileRoute } from "@tanstack/react-router";

/**
 * `/{group}/{project}/-/work_items` — the GitLab-native
 * project-scoped work-item list. Same page as the internal
 * `/projects/{slug}/work-items` route; resolves the project from
 * the second URL segment (the slug).
 */
export const Route = createFileRoute("/_app/$group/$project/-/work_items/")({
  validateSearch: workItemsSearchSchema,
  loaderDeps: ({ search }) => ({
    q: search.q,
    status: search.status,
    priority: search.priority,
    type: search.type,
    assignee: search.assignee,
    author: search.author,
    watcher: search.watcher,
    attachments: search.attachments,
    scope: search.scope,
    dueAfter: search.dueAfter,
    dueBefore: search.dueBefore,
    sort: search.sort,
    dir: search.dir,
    page: search.page,
    pageSize: search.pageSize,
  }),
  loader: ({ params, deps }) => loadProjectWorkItems(params.project, deps),
  component: ProjectWorkItemsPage,
});
